const Form = require('./form.jsx');
const React = require('react');
const ReactHelmet = require('react-helmet');


const Helmet = ReactHelmet.Helmet;


class ContactPage extends React.Component {
    render() {

        return (
            <div className="content-wrapper">
                <Helmet>
                    <title>Contact us</title>
                </Helmet>
                <div className="box">
                    <div className="box-body">
                        <div className="row">
                            <div className="col-sm-6">
                                <Form />
                            </div>
                            <div className="col-sm-6 text-center">
                                {/*<h1 className="page-header">Contact us</h1>
                                <p className="lead">
                                    Freddy can’t wait to hear from you.
                                </p>
                                <i className="fa fa-reply-all bamf"></i>
                                <div>
                                    1428 Elm Street &bull; San Francisco, CA 94122
                                </div>*/}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


module.exports = ContactPage;



// WEBPACK FOOTER //
// client/pages/main/contact/index.jsx